@if (debugService.isModifyingState()) {
  <div
    palantirTooltip="O menu de desenvolvedor está ativamente modificando o estado da aplicação."
    class="absolute bottom-4 right-4 z-50 flex size-8 items-center justify-center rounded-full border border-solid border-amber-400 bg-amber-500/10 text-amber-500 shadow-sm"
  >
    &lt;/&gt;
  </div>
}
